<template>
  <div class="pc-box">
    <span class="pc-search-box">课程搜索:</span>
    <el-input
        class="pc-search-input"
        placeholder="请输入内容"
        v-model="value"
        @input="editText"
    >
      <i slot="prefix" class="el-input__icon el-icon-search"></i>
    </el-input>
  </div>
</template>

<script>
	export default {
		name: "searchBox",
    props:['courseName'],
    data() {
			return {
				context:'',
        value: this.courseName
      }
    },
    methods:{
	    editText(t) {
		    this.$emit('searchChanges',t)
      },
    },
	}
</script>

<style lang="less" scoped>
.pc-box{
  margin: 0 auto;
}
  .pc-search-box{
    font-size: 16px;
    font-weight: bolder;
    margin-right: 10px;
  }
  .pc-search-input{
    width: calc(100% - 80px);
    .el-input__icon{
      color: #1ec78d;
      font-size: 16px;
      font-weight: bolder;
    }
  }
</style>